import { DistributionType, EstateType, LocationType } from '@aviv-search/types';
export const getDefaultModel = (defaultPlaceId) => ({
    distributionTypes: [DistributionType.BUY, DistributionType.BUY_AUCTION, DistributionType.COMPULSORY_AUCTION],
    estateTypes: [EstateType.HOUSE],
    locations: [{ type: LocationType.PLACE_ID, placeId: defaultPlaceId }],
});
